import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:dd0a420a-4774-4293-af16-1b7e8d900e56",
    aws_user_pools_id: "eu-west-1_7dfPivdPI",
    aws_user_pools_web_client_id: "6v9s6qdvikmi0gb899uni9kps6",
    Auth: {
      identityPoolId: "eu-west-1:dd0a420a-4774-4293-af16-1b7e8d900e56",
      region: "eu-west-1",
      userPoolId: "eu-west-1_7dfPivdPI",
      userPoolWebClientId: "6v9s6qdvikmi0gb899uni9kps6",
    },
    oauth: {
      domain: "whs-safer-beta-eu.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://beta.eu.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.eu.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
